export const REFERRALS_PATH = '/referrals';

export const routePaths = {
  REFERRALS_PATH
};

export default routePaths;
